export interface AssinaturaStatus {
  status: StatusAssinatura;
  formaPagamento: FormaPagamentoAssinatura;
  dataProximoVencimento: string | null;
  dataUltimoPagamento: string | null;
  valor: number;
  ativa: boolean;
  temCobrancaPendente: boolean;
}

export interface AssinaturaResultado {
  assinaturaId: string;
  status: string;
  urlPagamento: string | null;
  qrCodePix: string | null;
  qrCodePixImagem: string | null;
  linhaDigitavel: string | null;
  formaPagamento: string;
}

export interface CriarAssinatura {
  formaPagamento: FormaPagamentoAssinatura;
}

export enum StatusAssinatura {
  Pendente = 1,
  Ativa = 2,
  Cancelada = 3,
  Expirada = 4,
  Inadimplente = 5,
}

export enum FormaPagamentoAssinatura {
  PIX = 1,
  Boleto = 2,
  CartaoCredito = 3,
}

export class DescricaoStatusAssinatura {
  static obter(status: StatusAssinatura): { texto: string; cor: string; icone: string } {
    switch (status) {
      case StatusAssinatura.Ativa:
        return { texto: 'Ativa', cor: '#4caf50', icone: 'check_circle' };
      case StatusAssinatura.Pendente:
        return { texto: 'Pendente', cor: '#ff9800', icone: 'hourglass_empty' };
      case StatusAssinatura.Cancelada:
        return { texto: 'Cancelada', cor: '#9e9e9e', icone: 'cancel' };
      case StatusAssinatura.Expirada:
        return { texto: 'Expirada', cor: '#f44336', icone: 'event_busy' };
      case StatusAssinatura.Inadimplente:
        return { texto: 'Inadimplente', cor: '#f44336', icone: 'warning' };
      default:
        return { texto: 'Desconhecido', cor: '#9e9e9e', icone: 'help' };
    }
  }
}

export class DescricaoFormaPagamento {
  static obter(forma: FormaPagamentoAssinatura): { texto: string; icone: string } {
    switch (forma) {
      case FormaPagamentoAssinatura.PIX:
        return { texto: 'PIX', icone: 'qr_code_2' };
      case FormaPagamentoAssinatura.Boleto:
        return { texto: 'Boleto', icone: 'receipt' };
      case FormaPagamentoAssinatura.CartaoCredito:
        return { texto: 'Cartão de Crédito', icone: 'credit_card' };
      default:
        return { texto: 'Não informado', icone: 'payment' };
    }
  }

  static todos(): { valor: FormaPagamentoAssinatura; texto: string; icone: string }[] {
    return [
      { valor: FormaPagamentoAssinatura.PIX, texto: 'PIX', icone: 'qr_code_2' },
      { valor: FormaPagamentoAssinatura.Boleto, texto: 'Boleto Bancário', icone: 'receipt' },
      { valor: FormaPagamentoAssinatura.CartaoCredito, texto: 'Cartão de Crédito', icone: 'credit_card' },
    ];
  }
}
